<template>
  <div style="height: 20px; margin: 0">
    <input
      ref="rng"
      type="range"
      step="1"
      min="50"
      max="500"
      @change="setDpi"
    />
  </div>
</template>

<script>
import { Axios } from "@/services/_axios";

let dpiTimer = null;
export default {
  props: ["title"],
  async mounted() {
    const { data } = await Axios.get("/api/general/get-dpi");
    this.$refs.rng.value = data.dpi;
  },
  methods: {
    async setDpi(e) {
      await Axios.post("/api/general/set-dpi", { dpi: this.$refs.rng.value });
      this.$store.state.reloadAllPages++;
    },
    async setDpiOnDrag(e) {
      dpiTimer = setTimeout(async () => {
        if (dpiTimer) clearTimeout(dpiTimer);
        await Axios.post("/api/general/set-dpi", { dpi: this.$refs.rng.value });
        this.$store.state.reloadAllPages++;
      }, 200);
    },
  },
};
</script>

<style lang="scss" scoped>
.container {
  width: 100%;
  padding: 15px;
  display: flex;
  align-items: flex-start;
  justify-content: center;
  gap: 10px;
}
</style>
